/** Отображаемые названия типа штрафа (в БД/API остаются FIXED / PERCENT). */
export const PENALTY_TYPE_LABELS = {
  FIXED: 'Фиксированная сумма',
  PERCENT: 'Процент (%)'
} as const;

export type PenaltyTypeCode = keyof typeof PENALTY_TYPE_LABELS;

export function penaltyTypeLabel(type: string | undefined | null): string {
  const code = String(type ?? '')
    .toUpperCase()
    .trim() as PenaltyTypeCode;
  if (code in PENALTY_TYPE_LABELS) {
    return PENALTY_TYPE_LABELS[code];
  }
  return type != null && String(type) !== '' ? String(type) : PENALTY_TYPE_LABELS.FIXED;
}
